import React from 'react';
import { GoldPlaque } from './GoldPlaque';
type SectionHeadingProps = {
  id: string;
  eyebrow: string;
  lead: string;
  highlight: string;
  intro?: string;
  tone?: 'dark' | 'light';
};
export function SectionHeading({
  id,
  eyebrow,
  lead,
  highlight,
  intro,
  tone = 'dark'
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-274" data-mp="rwpyoj5prlik">
      <GoldPlaque tone={tone} data-id="element-275" data-mp="s043rz5ri8tp">{eyebrow}</GoldPlaque>
      <h2 id={id} className="mt-5 font-display text-[34px] font-bold uppercase leading-[0.98] min-[400px]:text-[38px] sm:mt-6 sm:text-[52px] lg:text-[60px]" data-id="element-276" data-mp="mzgbzb9plnyf">
        {lead} <span className={tone === 'dark' ? 'text-gold' : 'text-gold-dark'} data-id="element-277" data-mp="d9wrk16clm1g">{highlight}</span>
      </h2>
      {intro && <p className={`mx-auto mt-4 max-w-2xl text-base leading-relaxed sm:mt-5 sm:text-lg ${tone === 'dark' ? 'text-white/80' : 'text-[#374151]'}`} data-id="element-278" data-mp="8bd6e2zkwea5">
          {intro}
        </p>}
    </div>;
}